import { render, staticRenderFns } from "./StockAlerts.vue?vue&type=template&id=5aaf8294"
import script from "./StockAlerts.vue?vue&type=script&lang=js"
export * from "./StockAlerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports